import Types from "./Types";

export const getAllGroupsRequest = (body) => ({
  type: Types.GET_GROUPS_STUDENT_REQUEST,
  payload: body,
});

export const getAllGroupsSuccess = (data) => ({
  type: Types.GET_GROUPS_STUDENT_SUCCESS,
  payload: data,
});

export const getAllGroupsFail = () => ({
  type: Types.GET_GROUPS_STUDENT_FAIL,
});

//LOADING
export const groupLoading = (isLoading) => ({
  type: Types.GROUPS_LOADING,
  payload: isLoading,
});
